import React, { Component } from 'react';
import { Patients, AddPatient, Patient } from '../components';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import moment from 'moment';
import { patientList as listActions, patient as patientActions, auth as authActions } from '../actions';

@connect((state) => ({
  patientsData: state.patients,
  sessionData: state.session
}))
export default class PatientsPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      controls: new Map({
        ba: 'default',
        mindfulness: 'default',
        adherence: 'default'
      })
    };
  }
  
  componentDidMount() {
    this.props.dispatch(listActions.loadPatients());
    this.loadNewRoute(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const { dispatch, patientsData } = nextProps;

    if ( this.subroute(nextProps) !== this.subroute() ) {
      this.loadNewRoute(nextProps);
    }
  }
  
  render() {
    const subroute = this.subroute();
    const { patientsData, sessionData } = this.props;
    const now = moment();
    
    if ( !subroute ) {
      const allPatients = patientsData.get('patientsById').valueSeq().toList().map((p) => p.get('patient')).toList().concat(
        patientsData.get('pendingPatients')
      );
      return (
        <Patients patients={allPatients}
                  user={sessionData.get('user')}
                  onLogout={this.onLogout}/>
      );
    } else if ( this.isPatientRoute(this.props) ) {
      const id = +this.subroute(this.props);
      const patient = patientsData.get('patientsById').getIn([ id, 'patient' ]);
      return (
        <Patient patient={patient}
                 controls={this.state.controls}
                 onUpdateControls={(controls) => this.setState({ controls })} />
      );
    }
    return null;
  }

  loadNewRoute = (props) => {
    if ( this.isPatientRoute(props) ) {
      const patientId = this.subroute(props);
      props.dispatch(patientActions.loadPatient(patientId));
    }
  }
  
  subroute = (_props) => {
    const props = _props || this.props;
    return props.location.pathname.split('/').slice(2)[0];
  };

  isPatientRoute = (_props) => {
    const props = _props || this.props;
    return !isNaN(parseInt(this.subroute(props), 10));
  };

  onLogout = () => {
    this.props.dispatch(authActions.logout());
  };
}



// WEBPACK FOOTER //
// ./src/pages/patients.js